import { render, staticRenderFns } from "./ViewHolidayPage.vue?vue&type=template&id=794a79c1&"
import script from "./ViewHolidayPage.vue?vue&type=script&lang=js&"
export * from "./ViewHolidayPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports